import { QuerySummary as HeadlessQuerySummary, Sort as HeadlessSort } from "@coveo/headless";
import { useEffect, useState } from "react";
import Sort from "components/coveo-headless/components/Sort";
import { SortByDictionary } from "components/coveo-headless/types/coveo-headless-types";

type SearchPageHeaderProps = {
	controller: HeadlessQuerySummary;
	criteriaDictionary: SortByDictionary[];
	sortCriteria: HeadlessSort;
};

const SearchPageHeaderSort = ({
	controller,
	criteriaDictionary,
	sortCriteria
}: SearchPageHeaderProps) => {
	const [state, setState] = useState(controller.state);
	useEffect(() => controller.subscribe(() => setState(controller.state)), [controller]);

	return (
		<>
			{state.hasResults && (
				<div className="search-page-sortBy">
					<Sort controller={sortCriteria} criteria={criteriaDictionary} />
				</div>
			)}
		</>
	);
};

export default SearchPageHeaderSort;
